import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  display: flex;
  align-items: center;

  ${({ simpleForm }) =>
    !simpleForm &&
    css`
      flex-direction: column;
      background-color: ${(props) => props.theme.colors.secondary};
      bottom: 0;
      left: 0;
      z-index: 10;
      width: 100vw;
      padding: 1rem;
      border-radius: 1rem 1rem 0 0;
      box-sizing: border-box;
      justify-content: space-evenly;
      position: fixed;

      > :not(.additional-text) {
        width: 100%;
      }

      > .additional-text {
        padding: 0.5rem 0;
      }

      ${breakpoint("tablet")`
        width: auto;
        right: 5vw;
        left: auto;
        flex-direction: row;

        > :not(.additional-text) {
          width: auto;
          min-width: 10rem;
        }

        > .additional-text {
          padding: 0 0.5rem;
        }
      `}

      > :not(:last-child) {
        margin: 0 0 0.5rem 0;

        ${breakpoint("tablet")`
      margin: 0 1rem 0 0;
    `}
      }
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      gap: 16px;
    `}
`
